import { FmtpError, isFmtpError } from '@lanterds/types';
import env from '@ludovicm67/react-dotenv';
import { GENERIC_NETWORK_ERROR_MESSAGE } from 'src/util/constants';

type FmtpResponseError = {
    error: FmtpError;
};

export const baseUrl = env?.REACT_APP_REST_API_URL;

export const genericNetworkErrorHandler = async (response: Response) => {
    // Ignore 499 status codes since they represent aborted requests from the client
    if (response.status === 499) {
        return;
    }

    const results = await response.json();
    if (isResponseError(results)) {
        const { error } = results;
        const { message, errorCode } = error;
        throw new FmtpError({ message: message ?? GENERIC_NETWORK_ERROR_MESSAGE, ...(errorCode ? { errorCode } : {}) });
    } else {
        throw new FmtpError({ message: GENERIC_NETWORK_ERROR_MESSAGE });
    }
};

// Type guard function for FmtpResponseError
function isResponseError(resp: any): resp is FmtpResponseError {
    return resp && typeof resp === 'object' && 'error' in resp && isFmtpError(resp.error);
}
